import { isAndroid } from "react-device-detect";
import { isNotStandaloneMobilePWA } from "../../../utils/mobileSupported";

export const truncatePlayerName = (fullName = '') => {
    const clean = fullName.trim();
  
    let maxLength = 16;
  
    if (isNotStandaloneMobilePWA) {
      maxLength = isAndroid ? 12 : 14;
    }
  
    return clean.length > maxLength ? clean.slice(0, maxLength) + '…' : clean;
  };